/** Parse sections list response (E2EE or plain). */
export const extractOrgSectionsTableData = (secRes) => {
    if (!secRes || typeof secRes !== 'object') return [];
    const d = secRes.data;
    if (!d) return [];
    if (Array.isArray(d.tableData)) return d.tableData;
    if (Array.isArray(d.data?.tableData)) return d.data.tableData;
    if (Array.isArray(d)) return d;
    return [];
};

export const isOrgSectionRow = (r) => Number(r?.details_type) === 1;
